import React, { useEffect, useRef } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PrivateRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();
  const hasRedirected = useRef(false); // Track if redirection has already happened

  useEffect(() => {
    if (!isAuthenticated && !hasRedirected.current) {
      hasRedirected.current = true; // Set flag to prevent duplicate redirects
      localStorage.setItem('lasturl', location.pathname);
    }
  }, [isAuthenticated, location.pathname]);

  if (isAuthenticated === null) return null; // Show loader while checking authentication

  if (!isAuthenticated && hasRedirected.current) {
    return <Navigate to="/login" />;
  }

  return children;
};

export default PrivateRoute;
